import { Box } from '@chakra-ui/react';
import { Divider, Pagination } from '@time-line/components/common';
import { ProductReview } from 'components/reviews/ProductReview';
import type { JunipProductReview } from 'types/reviews';

export interface ProductReviewsPaginatedProps {
  showProduct?: boolean;
  paginatedReviews: JunipProductReview[][];
  pageNumber: number;
  handlePaginationChange: (pageNumber: number) => void;
}

export function ProductReviewsPaginated({
  showProduct,
  paginatedReviews,
  pageNumber,
  handlePaginationChange,
}: ProductReviewsPaginatedProps) {
  return (
    <>
      <Divider />
      {!!paginatedReviews.length &&
        paginatedReviews[pageNumber - 1].map((review, index) => (
          <ProductReview
            key={review.id}
            review={review}
            index={index}
            showProduct={showProduct}
          />
        ))}
      <Box pt="m">
        <Pagination
          onClick={handlePaginationChange}
          activePage={pageNumber}
          numberOfPages={paginatedReviews.length}
        />
      </Box>
    </>
  );
}
